module.exports = __webpack_public_path__ + "static/ecell-pb-logo-691062f846ace24759a3632357744e11.png";